import { uploadMethods } from '@/state/helpers';

export default {
    data() {
        return {
            pollIntervals: {}
        };
    },
    methods: {
        ...uploadMethods,

        async startPollingJobStatus(jobId, callback, callbackFail, resultData = {}, typeJob = 'upload') {
            let attempts = 0;
            const maxAttempts = 17280; // 1 day
            const intervalTime = 5000;
            let getJobStatus = null;
            switch (typeJob) {
                case 'upload':
                    getJobStatus = this.acgetJobStatusFile;
                    break;
                case 'importSerial':
                    getJobStatus = this.jobCheckImportSerial;
                    break;
                case 'autoGenSerial':
                    getJobStatus = this.jobCheckAutoGenSerial;
                    break;
                case 'deleteSerial':
                    getJobStatus = this.jobDeleteListSerial;
                    break;
                case 'deleteS3Analytics':
                    getJobStatus = this.jobDeleteS3AnalyticsStatus;
                    break;
            }
            return new Promise(() => {
                this.pollIntervals[jobId] = setInterval(async () => {
                    attempts++;
                    try {
                        const res = await getJobStatus(jobId);
                        if (['importSerial', 'autoGenSerial'].includes(typeJob)) {
                            if (!res || !res.status) {
                                this.clearPollInterval(jobId);
                                callbackFail(res);
                                return;
                            }
                        }

                        if ([1, 'completed'].includes(res?.data?.status)) {
                            const finalData = { ...resultData, ...res.data };
                            this.clearPollInterval(jobId);
                            callback(finalData);
                        } else if ([2, 'failed'].includes(res?.data?.status)) {
                            this.clearPollInterval(jobId);
                            callbackFail(res);
                        }
                    } catch (e) {
                        this.clearPollInterval(jobId);
                        callbackFail(e);
                    }
                    if (attempts >= maxAttempts) {
                        this.clearPollInterval(jobId);
                        callbackFail();
                    }
                }, intervalTime);
            });
        },

        clearPollInterval(jobId) {
            if (jobId && this.pollIntervals[jobId]) {
                clearInterval(this.pollIntervals[jobId]);
                delete this.pollIntervals[jobId];
            }
        },

        clearAllPollIntervals() {
            for (const key in this.pollIntervals) {
                if (this.pollIntervals[key]) {
                    clearInterval(this.pollIntervals[key]);
                }
            }
            this.pollIntervals = {};
        }
    },
    beforeDestroy() {
        this.clearAllPollIntervals();
    }
};
